import React from 'react';
import StarRating from "react-star-ratings";
import { vote } from "../../auth/apiProduct";


export const ratingVote =(a=[]) => {
    // No vote = 0 (0/0 was NaN, printed as "NaN" by `{rating && ...}` on Product Preview).
    if (!Array.isArray(a) || a.length === 0) return 0
    const sum = (total, num) => (
        total + Math.round(Number(num) || 0)
    ); 
    const sumVote = (
    a.map((p) => p?.voteNum)
    )
   const rating = parseFloat(sumVote.reduce(sum, 0) / a.length)
   return Number.isFinite(rating) ? rating : 0
}

class Vote extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            rating: props.rating,
            starSize : props.starSize? props.starSize : '22px',
            pending: false
        };
    }

    onStarClick(nextValue, prevValue,) {
        // this.setState({ rating: nextValue });
        const {productID, token, ButtonAddComments} = this.props
        if (!productID || !token || this.state.pending) return;

        this.setState({ pending: true });
        vote(productID, token, nextValue ).then( data => {
            if (!data) {
            }else{
                ButtonAddComments?.(false)
            }
            }).finally(() => this.setState({ pending: false }))
    }

    render() {
        const { rating, starSize } = this.state;
       
        const click = (clickShow) => ( 
            clickShow && ( this.onStarClick.bind(this)))


        return (
            <StarRating
            name="vote"
            numberOfStars={5}
            rating={rating}
            starRatedColor="goldenRod"
            starDimension={starSize}
            starSpacing="1px"
            changeRating={click(this.props.clickShow)}
            isSelectable={Boolean(this.props.clickShow && this.props.productID && !this.state.pending)}
        />
        );
    }
}

export default Vote;
